import {
  Button
} from "./chunk-UIKKGENA.mjs";
import {
  cn
} from "./chunk-DYSUVPH5.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-32ZPS4GN.mjs";

// src/quantity-stepper/TransparentQuantityStepper.tsx
import React from "react";
var StepButton = (_a) => {
  var _b = _a, { visible = true, disabled } = _b, rest = __objRest(_b, ["visible", "disabled"]);
  return /* @__PURE__ */ React.createElement(
    Button,
    __spreadValues({
      variant: "ghost-secondary",
      size: "sm",
      className: cn("px-2.5 py-2.5", {
        "!border-transparent !bg-transparent !opacity-50": disabled,
        invisible: !visible
      }),
      disabled
    }, rest)
  );
};
var IncrementIcon = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  },
  /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10, r: 9.5, fill: "none", stroke: "currentColor" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.714 10h8.572M10 5.714v8.572",
      stroke: "currentColor",
      strokeLinecap: "round"
    }
  )
);
var DecrementIcon = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  },
  /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10, r: 9.5, stroke: "currentColor" }),
  /* @__PURE__ */ React.createElement("path", { d: "M5.714 10h8.572", stroke: "currentColor", strokeLinecap: "round" })
);
var StepperClassNames = {
  container: "flex items-center justify-between text-foreground",
  value: "button my-label-md flex h-full select-none items-center justify-center text-center"
};
var StepperValue = (_a) => {
  var _b = _a, {
    children
  } = _b, rest = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ React.createElement("div", __spreadProps(__spreadValues({}, rest), { className: StepperClassNames.value }), children);
};
var TransparentQuantityStepper_default = {
  StepButton,
  DecrementIcon,
  IncrementIcon,
  StepperClassNames,
  StepperValue
};

export {
  StepperClassNames,
  TransparentQuantityStepper_default
};
